import { DeleteModal } from '@presentation/components/templates'

type Props = {
  id: string
  onDelete: () => void
}

const DeleteLotacaoModal: React.FC<Props> = ({ id, onDelete }) => {
  const modalConfigs = {
    id,
    path: '/lotacoes',
    nameForTitle: 'Lotacao',
    onDelete
  }

  return <DeleteModal {...modalConfigs} />
}

export default DeleteLotacaoModal
